import { render, staticRenderFns } from "./StockShowData.vue?vue&type=template&id=3b89ff12&"
import script from "./StockShowData.vue?vue&type=script&lang=js&"
export * from "./StockShowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports